/***
 *
 *   LOGO
 *   Replace the images in /public/assets with your own logo.
 *
 *   DOCS
 *   https://docs.useMapMetrics Atlas.app/MapMetrics Atlas-web/components/logo
 *
 *   PROPS
 *   className: custom styling (SCSS or tailwind style, optional)
 *   color: toggle between brand color or white logo (string, optional, default: white)
 *   mark: use logo mark or full logo (boolean, optional: default: full logo)
 *
 **********/

import { useContext } from "react";
import { AuthContext, Link, cn } from "components/lib";
import LogoWhite from "/assets/logo/logo-white.svg";
import LogoMarkWhite from "/assets/logo/fav.png";
import LogoColor from "/assets/logo/fav.png";
import LogoMarkColor from "/assets/logo/fav.png";

export function Logo({ className, color, mark, text }) {
  const authContext = useContext(AuthContext);
  const darkMode = authContext?.user?.dark_mode;

  // force white on dark mode
  if (darkMode) color = false;

  const Logo = {
    color: {
      logo: LogoColor,
      mark: LogoMarkColor,
    },
    white: {
      logo: LogoWhite,
      mark: LogoMarkWhite,
    },
  };

  const src = Logo[color ? "color" : "white"][mark ? "mark" : "logo"];

  return (
    <Link
      url="/dashboard"
      className={cn(
        "flex items-center gap-2 mx-auto outline-none no-underline mt-6 mb-10",
        className
      )}
    >
      {/* <img src={src} alt="Logo" className="mx-auto h-[36px]" /> */}
      <div className="mx-auto">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="70"
          height="65"
          viewBox="0 0 70 65"
          fill="none"
        >
          <path
            d="M15.122 37.8337C16.0546 36.0512 16.7511 34.7172 17.4476 33.3714C22.2995 24.0927 27.1396 14.8139 32.0151 5.54694C32.5227 4.57892 33.1012 3.62272 33.7741 2.76095C36.6782 -0.922222 41.1877 -0.945838 43.9737 2.84358C45.532 4.95668 46.8069 7.30589 48.0465 9.64328C54.6101 22.0032 61.1383 34.3748 67.6311 46.7701C69.3429 50.0283 70.4761 53.4518 69.8032 57.253C69.1068 61.1723 65.7541 64.5013 62.6376 64.6193C63.6292 62.5299 64.975 60.3577 65.7187 58.0085C66.8402 54.4316 65.6833 51.0317 64.0306 47.8326C59.8516 39.7579 55.6489 31.6951 51.3991 23.6677C48.3062 17.8242 45.0952 12.0397 41.9904 6.20801C41.2703 4.86224 40.3259 4.03589 38.7677 4.04769C37.2448 4.04769 36.3948 4.98029 35.7337 6.23163C31.0943 15.0618 26.3959 23.8447 21.8273 32.7103C20.8239 34.6582 19.7378 36.2518 17.4831 36.7949C16.822 36.9483 16.2199 37.3379 15.1102 37.8337H15.122Z"
            fill="#F8B14F"
          />
          <path
            d="M0 56.0609C2.63254 57.9969 5.53658 58.9059 8.78298 58.8586C12.0648 58.8114 14.8272 57.5719 17.4833 55.7303C20.777 53.4519 24.0116 50.9257 27.6475 49.3438C35.0021 46.1446 42.1914 47.3605 48.9085 51.6103C50.3015 52.4957 51.6119 53.511 52.934 54.5026C54.5631 55.7067 56.1804 55.8011 57.4554 54.7151C58.6477 53.6998 58.8838 52.0944 57.963 50.3472C52.3438 39.6755 46.8072 28.9683 40.9873 18.4028C39.6297 15.9237 39.37 13.4451 40.5505 12.8544C41.731 12.2638 43.1004 15.2033 43.2657 15.5102C49.5342 27.3861 54.7048 36.6061 60.9025 48.5292C61.6344 49.9458 62.2246 51.6694 62.1656 53.2158C61.9767 57.9497 57.0422 60.6294 52.5563 58.5281C51.2341 57.9024 50.0418 56.9462 48.8613 56.049C40.1727 49.4618 31.0592 49.6035 22.5595 56.4622C21.2728 57.5011 20.0214 58.5871 18.6875 59.5551C15.0751 62.1404 11.0732 63.2855 6.66988 62.3647C3.2346 61.6446 1.03885 59.4607 0 56.0609Z"
            fill="#00A69F"
          />
          <path
            d="M48.4522 46.2385C36.8832 41.8589 26.9079 44.1963 17.7235 51.1966C16.4486 52.1647 15.1973 53.1681 13.8751 54.0535C11.4196 55.6826 8.09058 55.659 5.93025 54.0653C3.87616 52.5542 2.91995 49.6148 3.68728 46.7698C4.02963 45.5066 4.52545 44.2553 5.13931 43.0984C11.5377 30.9628 17.8888 18.8036 24.4524 6.76247C25.8454 4.20078 26.483 2.60205 28.6905 2.28801C29.7378 2.13902 31.1238 1.85346 30.5793 2.7604C30.4022 3.05534 29.2571 4.73201 27.51 8.06103C20.9345 20.598 14.3827 33.1467 7.85448 45.7073C7.40589 46.5573 6.85103 47.6551 7.03991 48.4697C7.27602 49.4613 8.07877 50.5238 8.94055 51.1022C10.0856 51.8813 11.3606 51.3737 12.4349 50.512C16.6257 47.1593 21.0054 44.1254 26.0697 42.213C31.807 40.0527 37.6505 39.7576 43.6239 40.9381C45.253 41.2568 46.4807 41.9061 47.0592 43.5706C47.3425 44.3733 47.8383 45.1052 48.4286 46.2267L48.4522 46.2385Z"
            fill="#DF5D5D"
          />
        </svg>
      </div>
      {text && (
        <span className="text-[24px] dark:text-white text-primary font-semibold">
          {text}
        </span>
      )}
    </Link>
  );
}
